import { ReduxControls } from "rhombus-react";

import { CREATIVE_ASSET_TYPES, DYNAMIC_SOCIAL_AD_TYPES, PLATFORMS, SOCIAL_AD_TYPES, SOCIAL_FORMATS, VIDEO_AD_TYPES } from "utils/constants";
import { mapFacebookStringToOption, normalizeOptionToString } from "social/utils";

export const FORMAT_SELECT_INDEX = 0;
export const ADD_CONTENT_INDEX = 1;

export const ADTYPE_LABELS = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: "Image",
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: "Video",
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: "Carousel",
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: "Image",
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: "Video",
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: "Carousel",
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_IMAGE]: "Demand Gen Image",
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL]: "Demand Gen Carousel",
	[SOCIAL_AD_TYPES.LINKEDIN_IMAGE]: "Sponsored Image",
	[SOCIAL_AD_TYPES.LINKEDIN_VIDEO]: "Sponsored Video",
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]: "Sponsored Carousel",
	[SOCIAL_AD_TYPES.PINTEREST_IMAGE]: "Image Pin",
	[SOCIAL_AD_TYPES.PINTEREST_VIDEO]: "Video Pin",
	[SOCIAL_AD_TYPES.PINTEREST_MAX_WIDTH_VIDEO]: "Max Width Video",
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]: "Carousel",
	[SOCIAL_AD_TYPES.SNAPCHAT_IMAGE]: "Web View Image",
	[SOCIAL_AD_TYPES.SNAPCHAT_COMMERCIAL]: "Commercial Ad",
	[SOCIAL_AD_TYPES.SNAPCHAT_VIDEO]: "Web View Video",
	[SOCIAL_AD_TYPES.SNAPCHAT_CAROUSEL]: "Story Ad",
	[SOCIAL_AD_TYPES.TWITTER_IMAGE]: "Image Website Card",
	[SOCIAL_AD_TYPES.TWITTER_VIDEO]: "Video Website Card",
	// [SOCIAL_AD_TYPES.TWITTER_CAROUSEL]: "Website Carousel",
	[SOCIAL_AD_TYPES.YOUTUBE_INSTREAM]: "Video",
	[SOCIAL_AD_TYPES.YOUTUBE_DISCOVERY]: "TrueView Discovery",
	[SOCIAL_AD_TYPES.TIKTOK_VIDEO]: "In-Feed Video Ad",
	[SOCIAL_AD_TYPES.REDDIT_IMAGE]: "Image",
	[SOCIAL_AD_TYPES.REDDIT_VIDEO]: "Video",
};

export const FACEBOOK_DSP_INTERNAL_NAME = "facebook";
export const FACEBOOK_MO_DSP_INTERNAL_NAME = "facebook_mo";
export const GOOGLE_DSP_INTERNAL_NAME = "google_discovery_mo";
export const YOUTUBE_DSP_INTERNAL_NAME = "youtube";
export const LINKEDIN_DSP_INTERNAL_NAME = "linkedin_mo";
export const SNAPCHAT_DSP_INTERNAL_NAME = "snap_mo";
export const TWITTER_DSP_INTERNAL_NAME = "twitter_mo";
export const PINTEREST_DSP_INTERNAL_NAME = "pinterest_mo";
export const TIKTOK_DSP_INTERNAL_NAME = "tiktok_mo";
export const REDDIT_DSP_INTERNAL_NAME = "reddit";

export const PLATFORM_BY_DSP_INTERNAL_NAME = {
	[FACEBOOK_DSP_INTERNAL_NAME]: PLATFORMS.FACEBOOK,
	[FACEBOOK_MO_DSP_INTERNAL_NAME]: PLATFORMS.FACEBOOK_MO,
	[GOOGLE_DSP_INTERNAL_NAME]: PLATFORMS.GOOGLE,
	[YOUTUBE_DSP_INTERNAL_NAME]: PLATFORMS.YOUTUBE,
	[LINKEDIN_DSP_INTERNAL_NAME]: PLATFORMS.LINKEDIN,
	[SNAPCHAT_DSP_INTERNAL_NAME]: PLATFORMS.SNAPCHAT,
	[TWITTER_DSP_INTERNAL_NAME]: PLATFORMS.TWITTER,
	[PINTEREST_DSP_INTERNAL_NAME]: PLATFORMS.PINTEREST,
	[TIKTOK_DSP_INTERNAL_NAME]: PLATFORMS.TIKTOK,
	[REDDIT_DSP_INTERNAL_NAME]: PLATFORMS.REDDIT,
};

export const TWITTER_CONVERSATION_CONTROL_OPTIONS = [
	{
		label: "Everyone",
		value: "Everyone",
	},
	{
		label: "Following",
		value: "Following",
	},
	{
		label: "Mentioned Users",
		value: "Mentioned Users",
	},
];

export const PAC_FORM_TYPES = {
	DEFAULT: "Default",
	SQUARE: "Square",
	VERTICAL: "Vertical",
	HORIZONTAL: "Horizontal",
	REELS: "Reels",

	FB_FEEDS: "Facebook Feeds",
	FB_REELS: "Facebook Reels",
	FB_STORIES: "Facebook Stories",

	IG_EXPLORE: "Instagram Explore",
	IG_EXPLORE_HOME: "Instagram Explore Home",
	IG_FEEDS: "Instagram Feeds",
	IG_PROFILE_REELS: "Instagram Profile Reels",
	IG_REELS: "Instagram Reels",
	IG_STORIES: "Instagram Stories",

	FB_INSTREAM: "Facebook In-Stream Videos",
};

export const META_PAC_EXTERNAL_IDS = {
	[PAC_FORM_TYPES.SQUARE]: 'ft_aspect_square',
	[PAC_FORM_TYPES.VERTICAL]: 'ft_aspect_vertical',
	[PAC_FORM_TYPES.HORIZONTAL]: 'ft_aspect_horizontal',
	[PAC_FORM_TYPES.REELS]: 'ft_placement_reels',
	[PAC_FORM_TYPES.FB_FEEDS]: 'ft_placement_fb_feeds',
	[PAC_FORM_TYPES.FB_REELS]: 'ft_placement_fb_reels',
	[PAC_FORM_TYPES.FB_STORIES]: 'ft_placement_fb_stories',
	[PAC_FORM_TYPES.FB_INSTREAM]: 'ft_placement_fb_instream',
	[PAC_FORM_TYPES.IG_FEEDS]: 'ft_placement_inst_feeds',
	[PAC_FORM_TYPES.IG_REELS]: 'ft_placement_inst_reels',
	[PAC_FORM_TYPES.IG_STORIES]: 'ft_placement_inst_stories',
	[PAC_FORM_TYPES.IG_EXPLORE]: 'ft_placement_inst_explore',
	[PAC_FORM_TYPES.IG_EXPLORE_HOME]: 'ft_placement_inst_explore_home',
	[PAC_FORM_TYPES.IG_PROFILE_REELS]: 'ft_placement_inst_profile_reels_explore',
};


export const PAC_FORM_TYPES_LIST = Object.values(PAC_FORM_TYPES);

export const PAC_TYPES = {
	NONE: "none",
	ASPECT_RATIO: "aspectRatio",
	PLACEMENT: "placement",
};

export const PAC_TYPE_LABELS = {
	[PAC_TYPES.ASPECT_RATIO]: "Aspect Ratio",
	[PAC_TYPES.PLACEMENT]: "Placement",
};

export const facebookPagesTextProps = {
	component: ReduxControls.Input,
	normalize: mapFacebookStringToOption,
	format: normalizeOptionToString,
	placeholder: "Enter Facebook Page id",
};

export const instagramTextProps = {
	component: ReduxControls.Input,
	normalize: mapFacebookStringToOption,
	format: normalizeOptionToString,
	placeholder: "Enter Instagram account id",
};

export const MAX_CAROUSEL_CARDS_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: 10,
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: 10,
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL]: 10,
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]: 5,
	[SOCIAL_AD_TYPES.TWITTER_CAROUSEL]: 6,
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]: 10,
	[SOCIAL_AD_TYPES.SNAPCHAT_CAROUSEL]: 10,
};

export const DEFAULT_MIN_CAROUSEL_CARDS = 2;

// Please omit adding new values to this object if it's equal to the default value
export const MIN_CAROUSEL_CARDS_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.SNAPCHAT_CAROUSEL]: 1,
};

export const ALLOWED_CARD_TYPES_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE,
		SOCIAL_FORMATS.VIDEO
	],
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: [
		SOCIAL_FORMATS.IMAGE,
		SOCIAL_FORMATS.VIDEO
	],
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE
	],
	[SOCIAL_AD_TYPES.TWITTER_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE,
		SOCIAL_FORMATS.VIDEO
	],
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE
	],
	[SOCIAL_AD_TYPES.SNAPCHAT_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE,
		SOCIAL_FORMATS.VIDEO
	],
};

export const PAC_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
	],
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
		PAC_FORM_TYPES.REELS
	],
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
	],
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
		PAC_FORM_TYPES.FB_STORIES,
		// PAC_FORM_TYPES.REELS, // These still exist, but are deprecated and shouldn't be addable
		PAC_FORM_TYPES.FB_FEEDS,
		PAC_FORM_TYPES.FB_REELS,
		PAC_FORM_TYPES.FB_INSTREAM,
		PAC_FORM_TYPES.IG_FEEDS,
		PAC_FORM_TYPES.IG_REELS,
		PAC_FORM_TYPES.IG_EXPLORE_HOME,
		PAC_FORM_TYPES.IG_PROFILE_REELS,
		PAC_FORM_TYPES.IG_STORIES,
		PAC_FORM_TYPES.IG_EXPLORE,
	],
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
	],
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
		PAC_FORM_TYPES.FB_STORIES,
		// PAC_FORM_TYPES.REELS, // These still exist, but are deprecated and shouldn't be addable
		PAC_FORM_TYPES.FB_FEEDS,
		PAC_FORM_TYPES.FB_REELS,
		PAC_FORM_TYPES.FB_INSTREAM,
		PAC_FORM_TYPES.IG_FEEDS,
		PAC_FORM_TYPES.IG_REELS,
		PAC_FORM_TYPES.IG_EXPLORE_HOME,
		PAC_FORM_TYPES.IG_PROFILE_REELS,
		PAC_FORM_TYPES.IG_STORIES,
		PAC_FORM_TYPES.IG_EXPLORE,
	],
};

export const GOOGLE_ASPECT_RATIO_LABELS = {
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL]: {
		square: "Square (YouTube Mobile)",
		horizontal: "Horizontal (YouTube Mobile)",
		vertical: "Vertical (Discover)",
	},
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_IMAGE]: {
		square: "Square (Gmail Mobile)",
		horizontal: "Horizontal (Gmail Mobile)",
		vertical: "Vertical (Gmail Mobile)",
	},
};

/* Disabled Features Messages Versions*/
export const UNEDITABLE_DYNAMIC_VARIABLE_MESSAGE = "Dynamic variables cannot be modified for creatives that have versions. Please remove non-default versions if you would like to change dynamic variables.";
export const UNEDITABLE_CARD_MESSAGE = "Cards cannot be added or removed once the creative has versions";
export const UNEDITABLE_CARD_ASSET_TYPE_MESSAGE = "Card types cannot be edited once the creative has versions";
export const AE_CARD_IMAGE_DISABLED_MESSAGE = "After Effects build method only supports Video cards";

export const FACEBOOK_DISCLAIMER_IDS = {
	HEALTH_DISCLAIMER: 'Health Disclaimer',
	IMPORTANT_SAFETY_INFORMATION: 'Important Safety Information',
	MEDICATION_GUIDE: 'Medication Guide',
	OFFER_DETAILS: 'Offer Details',
	PRESCRIBING_INFORMATION: 'Prescribing Information',
	TERMS_AND_CONDITIONS: 'Terms and Conditions',
};

export const [FACEBOOK_DISCLAIMER_DEFAULT_ID] = Object.keys(FACEBOOK_DISCLAIMER_IDS);

export const FACEBOOK_MAX_DISCLAIMER_TEXT_LENGTH = 32000;
export const FACEBOOK_MAX_DISCLAIMER_URL_LENGTH = 800;

export const TIKTOK_DISCLAIMER_TYPES = {
	STANDARD: "standard",
	CLICKABLE: "clickable",
};

export const TIKTOK_DISCLAIMER_DEFAULT_TYPE = TIKTOK_DISCLAIMER_TYPES.STANDARD;

export const TIKTOK_STANDARD_DISCLAIMER_MAX_LENGTH = 90;
export const TIKTOK_CLICKABLE_TEXT_MAX_LENGTH = 40;
export const TIKTOK_MAX_CLICKABLE_OPTIONS = 3;

export const IMPOSIUM_PROJECT_CREATION_METHOD = {
	NEW_PROJECT: "new_project",
	EXISTING_PROJECT: "ex_project",
};

export const IMPOSIUM_COMP_CREATION_METHOD = {
	NEW_COMPOSITION: "new_comp",
	EXISTING_COMPOSITION: "ex_comp",
};

export const DYNAMIC_ONLY_ASSET_TYPES = [
	CREATIVE_ASSET_TYPES.IMPOSIUM,
	CREATIVE_ASSET_TYPES.AFTER_EFFECTS,
];

export const AE_SUPPORTED_AD_TYPES = [
	...VIDEO_AD_TYPES.filter(type => DYNAMIC_SOCIAL_AD_TYPES.includes(type)),
	SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO,
];
